import { useQuery } from '@tanstack/react-query';

import {
  postCompanyQuestion,
  TCompanyQuestionRequest,
} from './fetchPostCompanyQuestion';
import { useGetApplicationQuery } from '../lendingApi/lendingApiQueries';

export function useGetCompanyQuestion({
  contextData,
  enabled,
}: {
  contextData: TCompanyQuestionRequest['context'];
  enabled?: boolean;
}) {
  const { application } = useGetApplicationQuery();

  const { data, isLoading, isError } = useQuery({
    queryKey: [
      'fetchGetCompanyQuestion',
      application?.application_id,
      contextData,
    ],
    queryFn: () =>
      postCompanyQuestion({
        applicationId: application?.application_id as string,
        data: {
          context: contextData,
          history: [],
        },
      }),
    enabled: enabled && Boolean(application?.application_id),
  });

  return {
    initialQuestion: data?.inference_question,
    isInitialCompanyQuestionLoading: isLoading,
    isInitialCompanyQuestionError: isError,
  };
}
